<template>
  <div class="row justify-content-center">
    <loader :loading="loading"></loader>
    <div v-if="surveyInitialized" class="col-md-6">
      <sidebar-share v-if="enableColorSchemeChange" @darkModeToggled="handleDarkModeToggled"/>
      <survey-header
        :title="surveyName"
        :displayOptions="getDisplayOptionsByType(displayTypes.HEADER)">
      </survey-header>
      <div class="row mb-3">
        <div class="col">
          <card>
            <template slot="header">
              <label :for="`${_uid}-section-options`"><h3 class="card-title">Survey Review Panel</h3></label>
              <h5 class="card-category">This panel will not appear on the live survey and is only available for review purposes.</h5>
            </template>
            <div class="row">
              <div class="col col-md-8">
                <el-select
                  :id="`${_uid}-section-options`"
                  :class="`select-${colorScheme}`"
                  size="large"
                  placeholder="Single Select"
                  v-model="currentSectionId"
                  @change="handleReviewChange">
                  <el-option
                    v-for="option in activeSurveyNavSections"
                    :class="`select-${colorScheme}`"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </card>
        </div>
      </div>
      <survey-sections @nav="handleNav" :isDarkMode="isDarkMode"></survey-sections>
    </div>
  </div>
</template>
<script>
import Loader from './Loader';
import SurveyHeader from './SurveyHeader';
import SurveySections from './Sections';
import { Select, Option } from 'element-ui';
import { mapGetters, mapActions } from 'vuex';
import { getNavigationSectionId } from '../../modules/surveyActions';
import { isNullOrEmpty, isDarkMode, isDarkModeMedia, preventDarkMode } from 'src/modules/utils';
import SidebarShare from '../Layout/SidebarSharePlugin';

export default {
  components: {
    Loader,
    SidebarShare,
    SurveyHeader,
    SurveySections,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      sectionRouteName: 'ReviewSurveySection',
      isDarkMode: isDarkMode(),

      // Debugging variables
      enableColorSchemeChange: true,  // Whether to display the color scheme change plugin (change between dark and light mode)
      enableDarkMode: true, // Whether or not you can change the color scheme to dark mode using the plugin
    }
  },
  computed: {
    surveyName() {
      return this.activeSurvey ? this.activeSurvey.surveyName : '';
    },
    currentSectionId: {
      get() {
        return this.activeSectionId;
      },
      set(value) {
        this.setActiveSectionId(Number(value));
      }
    },
    loading() {
      return !this.surveyInitialized;
    },
    ...mapGetters([
      'colorScheme',
      'surveyInitialized',
      'activeSurvey',
      'activeSectionId',
      'activeSurveyNavSections',
      'displayTypes',
      'getDisplayOptionsByType',
    ])
  },
  methods: {
    handleDarkModeToggled(darkMode) {
      if (!this.enableDarkMode) {
        preventDarkMode();
        this.isDarkMode = isDarkMode();
      }
      else {
        this.isDarkMode = darkMode;
      }
    },
    handleReviewChange(val) {
      let newRoute = this.$router.currentRoute.path;
      let params = Object.assign({}, this.$route.params, {sectionId: val});
      this.$router.push({name: 'ReviewSurveySection', params: params});
    },
    async handleNav(type, categoryQuestionIds, passed) {
      if(type === 'previous') {
        this.setPreviousSection();
        this.triggerNav(type);
      }
      else if(type === 'next') {
        if(passed === true) {
          const response = await this.setNextSection();
          this.triggerNav(type, response);
        }
      }
    },
    triggerNav(type, completedMsg = null) {
      this.$emit('nav', type);
      let routeName = null;
      let params = {};

      const hasCompletedMsg = !isNullOrEmpty(completedMsg);
      if (this.currentSectionId === null || hasCompletedMsg) {
        routeName = 'Info';
        this.completeSurvey();
        params.type = 'completed';
        params.surveyId = this.$route.params.surveyId;
        if (hasCompletedMsg) {
          params.completedMsg = completedMsg;
        }
      }
      else {
        routeName = this.sectionRouteName;
        params = Object.assign(params, this.$route.params, {sectionId: this.currentSectionId});
      }

      this.$router.push({name: routeName, params: params});
    },
    completeSurvey() {
      this.setSurveyInitialized(false);
    },
    ...mapActions([
      'addActiveSurvey',
      'setActiveSectionId',
      'setSurveyInitialized',
      'setPreviousSection',
      'setNextSection'
    ])
  },
  created() {
    let payload = {
      surveyUrlId: this.$route.params.surveyId,
      review: true
    }

    this.addActiveSurvey(payload)
      .then(() => {
        let sectionId = getNavigationSectionId(this.$route.params.sectionId, true);
        this.currentSectionId = sectionId;

        if(this.$route.name !== this.sectionRouteName || +this.$route.params.sectionId !== +sectionId) {
          this.$router.replace({ name: this.sectionRouteName, params: Object.assign({}, this.$route.params, {sectionId: sectionId}) });
        }

        this.setSurveyInitialized(true);
      })
      .catch((error) => {
        this.$router.replace({ name: 'Welcome'});
      });
  },
  beforeRouteUpdate(to, from, next) {
    let sectionId = to.params.sectionId;
    let section = this.$store.getters.getNavSectionById(+sectionId);

    if(section) {
      this.currentSectionId = section.id;
      next();
    }
    else {
      next(false);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.setActiveSectionId(null);
    next();
  }
}
</script>
<style scoped>
.el-select {
  display: block;
}
</style>
